import {RegisterFormProps} from './Register.schema';

const CHAVE = 'millbody.register.draft.v1';
const VALIDADE_MS = 24 * 60 * 60 * 1000;

// Senha e CPF ficam de fora de proposito: sao os dois campos que nao podem
// sobrar no navegador de um computador compartilhado. O avatar tambem fica —
// um File nao serializa, e a pessoa escolhe de novo.
export const CAMPOS_PERSISTIDOS = [
  'name',
  'email',
  'phone',
  'atuation_type',
  'cref',
  'category',
  'subcategory',
  'zipcode',
  'street',
  'number',
  'complement',
  'neighborhood',
  'city',
  'state',
] as const;

export type CampoPersistido = (typeof CAMPOS_PERSISTIDOS)[number];
export type Rascunho = Partial<Record<CampoPersistido, string>>;

interface Envelope {
  versao: 1;
  salvoEm: number;
  step: number;
  campos: Rascunho;
}

export const filtrarCampos = (valores: Partial<RegisterFormProps> | Rascunho): Rascunho => {
  const rascunho: Rascunho = {};

  CAMPOS_PERSISTIDOS.forEach((campo) => {
    const valor = (valores as Record<string, unknown>)[campo];

    if (typeof valor === 'string' && valor.length > 0) rascunho[campo] = valor;
  });

  return rascunho;
};

const storage = (): Storage | null => {
  try {
    return window.sessionStorage;
  } catch {
    // Navegador com storage bloqueado nao pode derrubar o cadastro.
    return null;
  }
};

export const salvarRascunho = (valores: Partial<RegisterFormProps>, step: number): void => {
  const area = storage();
  if (!area) return;

  const envelope: Envelope = {versao: 1, salvoEm: Date.now(), step, campos: filtrarCampos(valores)};

  try {
    area.setItem(CHAVE, JSON.stringify(envelope));
  } catch {
    // Cota estourada: seguir sem rascunho e melhor que quebrar o formulario.
  }
};

export const lerRascunho = (agora: number = Date.now()): {campos: Rascunho; step: number} | null => {
  const area = storage();
  if (!area) return null;

  const bruto = area.getItem(CHAVE);
  if (!bruto) return null;

  try {
    const envelope = JSON.parse(bruto) as Envelope;

    if (envelope?.versao !== 1) return null;
    if (typeof envelope.salvoEm !== 'number') return null;
    if (agora - envelope.salvoEm > VALIDADE_MS) return null;

    // Reaplicar a allowlist na leitura: o que esta no storage pode ter sido
    // editado a mao ou vir de uma versao antiga do formulario.
    return {campos: filtrarCampos(envelope.campos ?? {}), step: envelope.step ?? 1};
  } catch {
    return null;
  }
};

export const limparRascunho = (): void => {
  storage()?.removeItem(CHAVE);
};
